const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20">
      {/* Background Gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-background via-primary/40 to-secondary/40"></div>
      
      {/* Dark Overlay for better text contrast */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>

      {/* Decorative Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-32 h-32 bg-white rounded-full blur-3xl"></div>
        <div className="absolute top-40 right-20 w-40 h-40 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-40 left-1/4 w-36 h-36 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-1/3 w-44 h-44 bg-white rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 py-8 sm:py-12 w-full">
        <div className="text-center">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-white/95 backdrop-blur-sm px-4 sm:px-5 py-2 rounded-full mb-6 sm:mb-8 shadow-lg">
            <i className="ri-heart-fill text-cta text-base sm:text-lg"></i>
            <span className="text-text-primary text-xs sm:text-sm font-medium">
              赤ちゃんの成長記録アプリ
            </span>
          </div>

          {/* Main Heading */}
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black font-maru text-white leading-tight mb-3 sm:mb-4 drop-shadow-lg px-4">
            赤ちゃんの成長を
            <br />
            毎日記録していきましょう
          </h1>
          <p className="text-lg sm:text-xl md:text-2xl font-medium text-white/95 mb-8 sm:mb-12 drop-shadow-md px-4">
            大切な瞬間を、いつまでも
          </p>

          {/* App Icon */}
          <div className="mb-8 sm:mb-10 flex justify-center">
            <div className="relative">
              <div className="absolute inset-0 bg-primary/40 rounded-full blur-2xl"></div>
              <img
                src="https://static.readdy.ai/image/982cbef0933d5cb0c5a33b0250e14312/63919f1218177b7717c8f3f0981d9dd4.png"
                alt="赤ちゃんダイアリー アイコン"
                className="relative w-24 h-24 sm:w-28 sm:h-28 md:w-32 md:h-32 rounded-2xl sm:rounded-3xl shadow-2xl"
              />
            </div>
          </div>

          {/* Download Button */}
          <div className="flex items-center justify-center mb-12 sm:mb-16 px-4">
            <a
              href="#"
              className="flex items-center gap-2 sm:gap-3 bg-black text-white px-6 sm:px-8 py-3 sm:py-4 rounded-xl hover:bg-black/90 transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer"
            >
              <i className="ri-apple-fill text-2xl sm:text-3xl"></i>
              <div className="text-left">
                <div className="text-xs opacity-90">Download on the</div>
                <div className="text-base sm:text-lg font-bold whitespace-nowrap">App Store</div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;